import {Injectable} from "@angular/core";
import {FormBuilder, FormControl, Validators} from "@angular/forms";
import {UmbrellaValidators} from "../../validation/umbrella-validators";
import {TranslateService} from "@ngx-translate/core";
import {ValidationMsg} from "../../services/standard-error-map";
import {StandaloneFormService} from "../../services/standalone-form.service";

@Injectable()
export class SalesForceCardFormService extends StandaloneFormService {

	readonly FORM_CONTROL_ERROR_MSG_MAP: { [validationKey: string]: ValidationMsg[] } = {
		minlength: [{msg: 'Provided opportunity id is too short'}],
		maxlength: [{msg: 'Provided opportunity id is too long'}],
	};

	constructor(private fb: FormBuilder, translate: TranslateService) {
		super(translate);
	}

	protected buildFormFor(formKey: string, [opportunityId]: [string]) {
		return this.fb.group({
			opportunityId: new FormControl(opportunityId, [Validators.required, UmbrellaValidators.nonEmpty, Validators.minLength(1), Validators.maxLength(100)])
		});
	}

	getControlNamesInOrder(): string[] {
		return ['opportunityId'];
	}

	protected override getFormSpecificErrorMap(): { [p: string]: ValidationMsg[] } {
		return this.FORM_CONTROL_ERROR_MSG_MAP;
	}
}
